<template>
  <SpaceOpener>
    <PasswordManager class="main"/>
  </SpaceOpener>
</template>

<script>
import PasswordManager from '../components/password-manager.vue';
import SpaceOpener from '../components/space-opener.vue'

export default {
  name: 'PasswordsPage',
  props: [],
  components: {
    PasswordManager,
    SpaceOpener,
  },
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
}
</script>

<style scoped>
</style>
